import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'sociuu-custom-interval-dialog',
  templateUrl: './custom-interval-dialog.component.html',
  styleUrls: ['./custom-interval-dialog.component.scss'],
})
export class CustomIntervalDialogComponent {
  public customIntervalForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<CustomIntervalDialogComponent>,
  ) {
    this.createCustomIntervalForm();
  }

  public createCustomIntervalForm(): void {
    this.customIntervalForm = this.fb.group({
      dateTo: '',
      dateFrom: '',
    });
  }

  public saveInterval(): void {
    const payload: { dateTo: string, dateFrom: string } = {
      dateTo: this.customIntervalForm.get('dateTo').value,
      dateFrom: this.customIntervalForm.get('dateFrom').value,
    };
    this.dialogRef.close(payload);
  }
}
